import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const tiles = [
  { title: "New Arrivals", sub: "Fresh styles. New vibes.", to: "/shop?tag=new", img: "/images/magenta-blazer.jpg" },
  { title: "Best Sellers", sub: "Customer favourites", to: "/shop?sort=rating", img: "/images/handbag.jpg" },
  { title: "Bundle & Save", sub: "More style. More savings.", to: "/shop?category=Gifts", img: "/images/jewelry-set.jpg" },
];

export const PromoTiles = () => (
  <section data-testid="promo-tiles" className="mx-auto grid max-w-7xl grid-cols-1 gap-4 px-4 sm:px-8 py-20 sm:grid-cols-2 lg:grid-cols-4">
    {tiles.map((t, i) => (
      <motion.div key={t.title} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: i * 0.08 }}>
        <Link to={t.to} data-testid={`promo-${t.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group relative flex h-64 flex-col justify-end overflow-hidden rounded-[1.75rem] p-6">
          <img src={t.img} alt={t.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] group-hover:scale-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-plum via-plum/50 to-transparent" />
          <div className="relative text-cream">
            <p className="font-display text-3xl uppercase leading-none tracking-tight">{t.title}</p>
            <p className="mt-2 font-display italic text-gold-light">{t.sub}</p>
            <span className="mt-4 inline-block rounded-full bg-magenta px-5 py-2 text-[10px] font-bold uppercase tracking-[0.22em] transition-colors group-hover:bg-white group-hover:text-plum">Shop now</span>
          </div>
        </Link>
      </motion.div>
    ))}
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.8, delay: 0.24 }}>
      <Link to="/shop?tag=sale" data-testid="promo-sale" className="group relative flex h-64 flex-col items-center justify-center overflow-hidden rounded-[1.75rem] bg-tangerine-deep p-6 text-center text-white">
        <span className="absolute -right-10 -top-10 h-40 w-40 rounded-full border-[18px] border-white/15 transition-transform duration-700 group-hover:scale-125" />
        <p className="eyebrow text-white/90">Shop the</p>
        <p className="font-display text-6xl font-black uppercase leading-none">Sale</p>
        <p className="mt-2 font-display text-lg italic">Up to 50% off</p>
        <span className="mt-5 rounded-full bg-white px-5 py-2 text-[10px] font-bold uppercase tracking-[0.22em] text-plum transition-colors group-hover:bg-plum group-hover:text-white">Shop now</span>
      </Link>
    </motion.div>
  </section>
);
